import { styled } from '@mui/material';

import Button from '../../../components/Button';

export const LogoutButton = styled(Button)(() => ({
  marginLeft: 'auto',
}));
